import React from "react";
import classes from "./LoginHome.scss";

import { Button } from "@toddle-edu/ds-web";

import {
  School3D,
  Student3D,
  Family3D,
  RightArrowOutlined,
} from "@toddle-edu/ds-icons";

import classNames from "classnames";
import { onEnterOrSpaceKeyDown } from "Utils";

class LoginHome extends React.PureComponent {
  onTeacherLoginClick = () => {
    const { updateCurrentScreen } = this.props;
    updateCurrentScreen({ type: "teacherLogin", userType: "staff" });
  };

  onStudentLoginClick = () => {
    const { updateCurrentScreen } = this.props;
    updateCurrentScreen({ type: "studentLogin", userType: "student" });
  };

  onFamilyLoginClick = () => {
    const { updateCurrentScreen } = this.props;
    updateCurrentScreen({ type: "parentLogin", userType: "parent" });
  };

  onVisitorLoginLink = () => {
    const { updateCurrentScreen } = this.props;
    updateCurrentScreen({
      type: "visitorLogin",
      userType: "staff",
      role: "visitor",
    });
  };

  onSchoolWorkspaceClick = () => {
    const { updateCurrentScreen } = this.props;
    updateCurrentScreen({
      type: "schoolCodeForm",
      paramsToBeRemoved: ["usertype"],
    });
  };

  onItemKeyDown = (e, accountType) => {
    switch (accountType) {
      case "teacherLogin":
        onEnterOrSpaceKeyDown(e, this.onTeacherLoginClick);
        break;
      case "studentLogin":
        onEnterOrSpaceKeyDown(e, this.onStudentLoginClick);
        break;
      case "familyLogin":
        onEnterOrSpaceKeyDown(e, this.onFamilyLoginClick);
        break;
      case "visitorLogin":
        onEnterOrSpaceKeyDown(e, this.onVisitorLoginLink);
        break;
    }
  };

  render() {
    const {
      renderTradeMarkText,
      customStyle: { headerStyle, subTextStyle } = {},
      renderRightSideLogo,
      isOrgWorkspaceLoginPage = false,
      schoolName = "Toddle",
      isOrgWorkspaceLoginEnabled = false,
      orgLogoUrl,
    } = this.props;

    const accountContainerClass = classNames(classes.accountContainer, "group");
    const bottomContainerClass = classNames(classes.bottomContainer, {
      [classes.schoolWorkspaceEnable]:
        !isOrgWorkspaceLoginPage && isOrgWorkspaceLoginEnabled,
      [classes.schoolWorkspaceDisable]:
        isOrgWorkspaceLoginPage || !isOrgWorkspaceLoginEnabled,
    });

    const containerStyle = {
      paddingTop: isOrgWorkspaceLoginPage ? "15%" : "24%",
    };

    return (
      <div
        className={classes.container}
        style={containerStyle}
        aria-labelledby="welcome-header"
      >
        <div>
          {isOrgWorkspaceLoginPage ? (
            orgLogoUrl ? (
              <div className={classes.logoContainer}>
                <img
                  className={classes.logoImage}
                  src={orgLogoUrl}
                  alt="Organisation logo"
                />
              </div>
            ) : null
          ) : (
            renderRightSideLogo()
          )}
          <div
            style={headerStyle}
            id="welcome-header"
          >{`Welcome to ${schoolName}!`}</div>
          <div style={subTextStyle}>Choose an account type to proceed</div>
          <div className={classes.buttonsContainer} aria-label="Login options">
            <div
              data-test-id="button-login-teacher"
              className={accountContainerClass}
              onClick={this.onTeacherLoginClick}
              onKeyDown={e => {
                this.onItemKeyDown(e, "teacherLogin");
              }}
              tabIndex="0"
              role="button"
              aria-labelledby="teacher-login-title"
            >
              <div className={classes.accountIcon}>
                <School3D />
              </div>
              <div className={classes.accountDetails}>
                <div id="teacher-login-title" className={classes.accountTitle}>
                  {"Teacher account"}
                </div>
                <div className={classes.accountDescription}>
                  {"I’m an educator/school admin/IT specialist"}
                </div>
              </div>
              <div className={classes.accountActionIcon}>
                <RightArrowOutlined size="xx-small" variant="subtle" />
              </div>
            </div>
            <div
              data-test-id="button-login-student"
              className={accountContainerClass}
              onClick={this.onStudentLoginClick}
              onKeyDown={e => {
                this.onItemKeyDown(e, "studentLogin");
              }}
              tabIndex="0"
              role="button"
              aria-labelledby="student-login-title"
            >
              <div className={classes.accountIcon}>
                <Student3D />
              </div>
              <div className={classes.accountDetails}>
                <div id="student-login-title" className={classes.accountTitle}>
                  {"Student account"}
                </div>
                <div className={classes.accountDescription}>
                  {"I’m a student"}
                </div>
              </div>
              <div className={classes.accountActionIcon}>
                <RightArrowOutlined size="xx-small" variant="subtle" />
              </div>
            </div>
            <div
              data-test-id="button-login-family"
              className={accountContainerClass}
              onClick={this.onFamilyLoginClick}
              onKeyDown={e => {
                this.onItemKeyDown(e, "familyLogin");
              }}
              tabIndex="0"
              role="button"
              aria-labelledby="family-login-title"
            >
              <div className={classes.accountIcon}>
                <Family3D />
              </div>
              <div className={classes.accountDetails}>
                <div id="family-login-title" className={classes.accountTitle}>
                  {"Family account"}
                </div>
                <div className={classes.accountDescription}>
                  {"I’m a family member"}
                </div>
              </div>
              <div className={classes.accountActionIcon}>
                <RightArrowOutlined size="xx-small" variant="subtle" />
              </div>
            </div>
          </div>
          <div className={bottomContainerClass}>
            {!isOrgWorkspaceLoginPage && isOrgWorkspaceLoginEnabled ? (
              <Button
                type="outlined"
                variant="outlined-subtle"
                size="medium"
                onClick={this.onSchoolWorkspaceClick}
                rightIcon={<RightArrowOutlined />}
                aria-label="Go to school workspace"
                className={classes.schoolWorkspaceButton}
              >
                {"School workspace"}
              </Button>
            ) : null}
            <div className={classes.signInAsVisitor}>
              {`Here as a visitor?`}
              <div
                data-test-id="button-login-visitor"
                className={classes.signInText}
                onClick={this.onVisitorLoginLink}
                onKeyDown={e => {
                  this.onItemKeyDown(e, "visitorLogin");
                }}
                tabIndex="0"
                role="button"
                aria-label="Sign in as visitor"
              >{`Sign-in here`}</div>
            </div>
          </div>
        </div>
        <div>
          {renderTradeMarkText({
            align: "left",
          })}
        </div>
      </div>
    );
  }
}

export default LoginHome;
